<template>
  <q-page class="page-layout home">
    <div class="home__container">
      <img
        class="home__logo"
        src="~@/assets/logo-light.svg"
        width="260px"
        alt="Casimba Gaming"
      />
      <div class="home__text" style="color: #1e1e1e">
        <p style="font-weight: bolder">Welcome Aboard the Client Portal!</p>
        <p style="font-size: 85%">
          Take Control of Your Brand: Monitor Visibility, Maximize Performance.
        </p>
      </div>
    </div>
  </q-page>
</template>

<script>
import { getStrapiContent } from "@/services/strapi-content/strapiContent";

export default {
  name: "Home",
  data() {
    return {
      interval: null,
      isContentLoaded: false,
      isAuthenticated: false,
      showError: { error: false, message: "" },
    };
  },
  methods: {
    // This is a work around and should be removed when we have a dedicated login page.
    async homepageCheckSession() {
      this.isAuthenticated = await this.$store.dispatch("checkSessionValid");
      if (!this.isAuthenticated) {
        this.$store.dispatch("logout");
      }
    },

    //fetching configurations from strapi for layout
    //and embeded dropbox links
    async fetchHomeConfigurations() {
      if (this.isAuthenticated) {
        await getStrapiContent("homepage")
          .then(async (response) => {
            // Assign response to this.categories to allow markup to look through objects
            if (response && response.data) {
              const data = await response.data.data;

              const {
                gamesCertificates,
                gamesLogos,
                gamesMasterList,
                restrictedTerritorie,
              } = data.attributes;

              // Example: Set the games certifications dropbox path
              this.$store.dispatch(
                "updateGamesCertificationsDropboxPath",
                gamesCertificates
              );

              // Example: Set the games logo dropbox path
              this.$store.dispatch("updateGamesLogoDropboxPath", gamesLogos);

              // Example: Set the games master list dropbox path
              this.$store.dispatch(
                "updateGamesMasterListDropboxPath",
                gamesMasterList
              );

              // Example: Set the restricted territories dropbox path
              this.$store.dispatch(
                "updateRestrictedTerritoriesDropboxPath",
                restrictedTerritorie
              );

              this.isContentLoaded = true;
            } else {
              this.isContentLoaded = false;
              this.showError = {
                error: true,
                message:
                  "Facing some issue while fetching content. Please try again.",
              };
            }
          })
          .catch((error) => {
            this.isContentLoaded = false;
            this.showError = {
              error: true,
              message: error.message,
            };
          });
      }
    },
  },
  async mounted() {
    await this.homepageCheckSession();
    this.interval = setInterval(() => {
      this.homepageCheckSession();
    }, 120000);

    await this.fetchHomeConfigurations();
  },
  computed: {
    isDarkMode() {
      return this.$q.dark.isActive;
    },
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style lang="scss" scoped>
.home {
  display: grid;
  place-items: center;
  background-image: url("~@/assets/bg.svg"); //home
  // background-position: center;
  // background-repeat: no-repeat;
  // background-size: cover;
  &__container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  &__logo {
    margin: 25px;
  }
  &__text {
    text-align: center;
    font-size: 22px;
    // @media only screen and (min-width: 600px) {
    //   font-size: 37px;
    // }
    // &--large {
    //   font-size: 49px;
    //   font-weight: 400;
    //   @media only screen and (min-width: 600px) {
    //     font-size: 65px;
    //   }
    // }
  }
}
</style>
